(() => {
  const number = (cents, decimals, thousands, decimal) => {
    const parts = (cents / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  };

  const formatMoney = (cents, format) =>
    format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return number(cents, 0, ',', '.');
        case 'amount_with_comma_separator':
          return number(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return number(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return number(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return number(cents, 0, ' ', ',');
        case 'amount_with_space_separator':
          return number(cents, 2, ' ', ',');
        default:
          return number(cents, 2, ',', '.');
      }
    });

  function init(root) {
    if (root.dataset.fcReady) return;
    root.dataset.fcReady = 'true';

    const variants = JSON.parse(root.querySelector('[data-fc-variants]').textContent);
    const groups = [...root.querySelectorAll('[data-fc-option]')];
    const idInput = root.querySelector('form [name="id"]');
    const button = root.querySelector('[name="add"]');
    const label = root.querySelector('[data-fc-add-label]');
    const priceNow = root.querySelector('[data-fc-price-now]');
    const priceWas = root.querySelector('[data-fc-price-was]');
    const main = root.querySelector('.fc-gallery__main img');
    const thumbs = [...root.querySelectorAll('[data-fc-thumb]')];
    const { moneyFormat, addLabel, soldOutLabel, unavailableLabel } = root.dataset;

    const find = (values) => variants.find((variant) => variant.o.every((value, i) => value === values[i]));

    const showMedia = (thumb) => {
      if (!main || !thumb) return;
      const src = thumb.dataset.src;
      main.srcset = [400, 600, 800, 1200].map((w) => `${src.replace(/width=\d+/, `width=${w}`)} ${w}w`).join(', ');
      main.src = src;
      main.alt = thumb.dataset.alt || '';
      thumbs.forEach((item) => item.setAttribute('aria-current', item === thumb));
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb)));

    const update = (userChange) => {
      const selected = groups.map((group) => group.querySelector('input:checked')?.value);
      const variant = find(selected);

      groups.forEach((group, i) => {
        group.querySelector('[data-fc-chosen]').textContent = selected[i];
        group.querySelectorAll('input').forEach((input) => {
          const candidate = find(selected.map((value, k) => (k === i ? input.value : value)));
          input.closest('.fc-pill').classList.toggle('is-unavailable', !candidate || !candidate.a);
        });
      });

      button.disabled = !variant || !variant.a;
      label.textContent = !variant ? unavailableLabel : variant.a ? addLabel : soldOutLabel;
      if (!variant) return;

      priceNow.textContent = formatMoney(variant.p, moneyFormat);
      priceWas.hidden = !(variant.c > variant.p);
      priceWas.textContent = formatMoney(variant.c, moneyFormat);

      if (!userChange) return;
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (variant.m) {
        const thumb = thumbs.find((item) => Number(item.dataset.mediaId) === variant.m);
        if (thumb) {
          showMedia(thumb);
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    groups.forEach((group) => group.addEventListener('change', () => update(true)));
    if (groups.length) update(false);
  }

  const initAll = () => document.querySelectorAll('[data-fc-product]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
